import React from 'react';
import { Badge } from '@/components/ui/badge';
import { InlineSelectCell } from './InlineSelectCell';
import { actionPriorityBadgeVariant } from './actionEditModel';
import {
  ACTION_PRIORITY_OPTIONS,
  DEFAULT_ACTION_PRIORITY,
} from '../ICSConstants';
import type { ActionEntity } from '../hooks/useScopedActionForm';

type PriorityCellProps = {
  action: ActionEntity;
  onChange: (patch: Record<string, unknown>) => void;
  disabled?: boolean;
};

/**
 * Priority was editable in the drawer and invisible in the table, which is the
 * wrong way round: triage happens in the list.
 */
export const PriorityCell: React.FC<PriorityCellProps> = ({
  action,
  onChange,
  disabled = false,
}) => {
  const priority = action.priority ?? DEFAULT_ACTION_PRIORITY;

  return (
    <InlineSelectCell
      options={ACTION_PRIORITY_OPTIONS}
      value={priority}
      onChange={(next) =>
        onChange({ priority: next ?? DEFAULT_ACTION_PRIORITY })
      }
      disabled={disabled}
      ariaLabel={`Priority for ${action.name || 'this task'}`}
      placeholder="Set priority"
      searchPlaceholder="Search priorities"
      field="priority"
    >
      <Badge variant={actionPriorityBadgeVariant(priority)}>{priority}</Badge>
    </InlineSelectCell>
  );
};

export default PriorityCell;
